/**
 * Custom Wines Showcase — hover-to-play video cards.
 *
 * Plays each card's video on mouseenter, resets on mouseleave. The crossfade
 * is handled in CSS; this just controls playback. Autoplay rejections (before
 * the hover counts as a user gesture) are swallowed — the resting image just
 * stays a beat longer. Re-binds on 'shopify:section:load' because the
 * customizer replaces the section DOM on every settings change.
 */
(function () {
  function bind(root) {
    (root || document).querySelectorAll('.custom-wines-showcase .cws-video').forEach(function (video) {
      if (video.dataset.cwsBound === 'true') return;
      video.dataset.cwsBound = 'true';

      var card = video.closest('.cws-card');
      if (!card) return;

      card.addEventListener('mouseenter', function () {
        video.play().catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
